class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          $(document).ready(function() {
            $('.slick-related').slick({
              dots: true,
              infinite: false,
              arrows: true,
              slidesToShow: 6,
              slidesToScroll: 6,
              nextArrow: '<button class="slick-next slick-arrow slick-disabled" aria-label="Next" type="button" aria-disabled="true"><svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow"><rect x="0.957031" y="0.239502" width="26.3716" height="26.3716" rx="4" fill="white"/><path d="M10.8372 17.1716V9.67503C10.8372 9.29222 11.2498 9.05141 11.5831 9.23967L18.1882 12.9705C18.5262 13.1614 18.5272 13.648 18.1899 13.8402L11.5848 17.606C11.2515 17.796 10.8372 17.5553 10.8372 17.1716Z" fill="black"/></svg></button>',
              prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" aria-disabled="false"><svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-arrow"><g clip-path="url(#clip0_51_7)"><path class="rect" d="M4.67137 0.239502H23.043C25.2521 0.239502 27.043 2.03036 27.043 4.2395V22.6111C27.043 24.8202 25.2521 26.6111 23.043 26.6111H4.67137C2.46223 26.6111 0.67137 24.8202 0.67137 22.6111V4.2395C0.67137 2.03036 2.46223 0.239502 4.67137 0.239502Z" fill="white"/><path class="arrow" d="M17.1628 17.1716V9.67503C17.1628 9.29222 16.7502 9.05141 16.4169 9.23967L9.81178 12.9705C9.47378 13.1614 9.47278 13.648 9.81008 13.8402L16.4152 17.606C16.7485 17.796 17.1628 17.5553 17.1628 17.1716Z" fill="black"/></g><defs><clipPath id="clip0_51_7"><rect width="28" height="27" fill="white" transform="matrix(-1 0 0 1 28 0)"/></clipPath></defs></svg></button>',
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    infinite: false,
                    dots: true
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: false,
                    dots: true
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                  }
                },
                {
                  breakpoint: 749,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    centerMode: true,
                    centerPadding: '25px',
                    infinite: true
                  }
                },
                {
                  breakpoint: 426,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    centerPadding: '25px',
                    infinite: true
                  }
                }
              ]
            });
          });

          /*$('.owl-related').owlCarousel({
            loop: false,
            margin: 10,
            dots: true,
            responsive:{
              0:{
                  items: 2
              },
              600:{
                  items: 4
              },
              1000:{
                  items: 6
              }
            }
          });*/
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);